export default "__VITE_ASSET__CIDplLRI__"